import { render } from "./userFormDialog.vue?vue&type=template&id=c6ca8308"
import script from "./userFormDialog.vue?vue&type=script&lang=js"
export * from "./userFormDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__